export default __webpack_public_path__ + "static/media/backoffice_quickguide.39b5be5a.pdf";